import React from "react";
import { Auth } from "../pages/Auth";
import { Link } from 'react-router-dom';
import { useInterestList } from '../context/InterestListContext';
import { useAuthContext } from '../context/AuthContext';
import { X, HeartStraight, ShoppingBag, Gear, Phone, SignOut } from 'phosphor-react';
import "./SideBarAuth.css";

export const SidebarAuth = ({ open, onClose, authMode = 'login' }) => {
  const { onLogout, interestList } = useInterestList();
  const { isAuthenticated, user, logout } = useAuthContext();

  const handleLogout = async () => {
    
    // Notificar contexto sobre logout
    onLogout();
    
    // Usar a função logout do contexto de autenticação
    logout();
    
    onClose();
  };

  const handleMenuClick = (action) => {
    if (action) action();
    onClose();
  };

  return (
    <>
      <div className={`sidebar-auth${open ? " open" : ""}`}>
        {isAuthenticated && user ? (
          <>
            {/* Header com saudação */}
            <div className="sidebar-header">
              <button className="close-btn" onClick={onClose}>
                <X size={20} />
              </button>
              <div className="user-greeting">Olá, {user.username}!</div>
              <div className="user-email">{user.email}</div>
            </div>

            {/* Conteúdo principal */}
            <div className="sidebar-content">
              <ul className="sidebar-menu">
                <li>
                  <Link 
                    to="/lista-interesse" 
                    className="menu-item"
                    onClick={() => handleMenuClick()}
                  >
                    <span className="menu-icon">
                      <HeartStraight size={20} />
                    </span>
                    <span>Lista de Interesses</span>
                    {interestList.length > 0 && (
                      <span className="interest-count">({interestList.length})</span>
                    )}
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/orders" 
                    className="menu-item"
                    onClick={() => handleMenuClick()}
                  >
                    <span className="menu-icon">
                      <ShoppingBag size={20} />
                    </span>
                    <span>Pedidos</span>
                  </Link>
                </li>
                {user && user.isAdmin && (
                  <li>
                    <Link 
                      to="/admin" 
                      className="menu-item"
                      onClick={() => handleMenuClick()}
                    >
                      <span className="menu-icon">
                        <Gear size={20} />
                      </span>
                      <span>Admin</span>
                    </Link>
                  </li>
                )}
                <li>
                  <Link 
                    to="/contactos" 
                    className="menu-item"
                    onClick={() => handleMenuClick()}
                  >
                    <span className="menu-icon">
                      <Phone size={20} />
                    </span>
                    <span>Contacte-nos</span>
                  </Link>
                </li>
              </ul>
            </div>

            {/* Seção de logout no final */}
            <div className="logout-section">
              <button className="logout-btn" onClick={handleLogout}>
                <span>
                  <SignOut size={20} />
                </span>
                <span>Terminar Sessão</span>
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="sidebar-header">
              <button className="close-btn" onClick={onClose}>
                <X size={20} />
              </button>
              <div className="user-greeting">Bem-vindo!</div>
              <div className="user-email">Faça login na sua conta</div>
            </div>
            <div className="auth-container">
              <Auth initialMode={authMode} />
            </div>
          </>
        )}
      </div>
      {open && <div className="sidebar-backdrop" onClick={onClose}></div>}
    </>
  );
};
